'use client';

import type { ReactNode } from 'react';
import { AuthProvider } from '@/components/AuthContext';

export default function CheckoutLayout({ children }: { children: ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>;
}
